module.exports = __webpack_public_path__ + "static/img/7.c6b035cd.png";